export interface IStatistics {
  id?: string;
  learnedWords: number;
  optional: IDayStatistic;
}

export interface IDayStatistic {
  [key: string]: IGameStatistics;
}

export interface IGameStatistics {
  audio: GameStatistics;
  sprint: GameStatistics;
  textbook: number;
}

export type GameStatistics = {
  right: number;
  wrong: number;
  new: number;
  strike: number;
  learned: number;
};
export enum StatisticsOption {
  TEXTBOOK = 'textbook',
  SPRINT = 'sprint',
  AUDIO = 'audio',
}
